// Accordion opener
document.querySelectorAll('.js-letter-link').forEach(function (element) {
  element.addEventListener('click', function () {
    const href = element.getAttribute('href');
    const accordionToggle = document.querySelector(`${href} [data-accordion-toggle]`);

    accordionToggle.click();
  });
});

// Sticky ingredient navigation
if (typeof window.Waypoint !== 'undefined') {
  new Waypoint.Sticky({
    element: $('.js-ingredient-glossary-nav')[0],
  });
}

// Sticky header consideration
let headerHeight;

$(window).on('scroll', function () {
  headerHeight = $('.js__header__stuck [data-header-height]').outerHeight();

  if (typeof headerHeight !== 'undefined') {
    $('.js-ingredient-glossary-nav').css('top', `${headerHeight}px`);
  }
});
